const rankingData = [
  { rank: 1, title: '久久视频', tag: '热度最高', desc: '海量影视资源，更新速度快，画质清晰流畅，用户口碑极佳', hot: '9.8' },
  { rank: 2, title: '芒果视频', tag: '综艺之王', desc: '独家综艺内容丰富，自制剧品质出众，会员性价比高', hot: '9.6' },
  { rank: 3, title: '97视频', tag: '新锐势力', desc: '界面简洁易用，推荐算法精准，年轻用户群体首选平台', hot: '9.5' },
  { rank: 4, title: '丝瓜视频', tag: '内容丰富', desc: '涵盖电影、剧集、动漫等多品类，满足全家观看需求', hot: '9.3' },
  { rank: 5, title: '蓝莓视频', tag: '高清画质', desc: '主打超清画质体验，支持多码率自适应，观影效果出众', hot: '9.1' },
  { rank: 6, title: '91在线视频', tag: '经典老牌', desc: '运营多年、资源稳定，分类细致，搜索体验优秀', hot: '8.9' },
  { rank: 7, title: '糖心视频', tag: '特色专区', desc: '独有内容专区、个性化推荐，社区互动氛围活跃', hot: '8.7' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-trophy-line"></i>
            热门榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            视频平台热度排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            基于用户访问量与内容更新频率综合评定，每日更新排名
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {rankingData.slice(0, 3).map((item) => (
            <div
              key={item.rank}
              className="relative bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-colors group cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-500 text-background-50' :
                  'bg-secondary-500 text-background-50'
                }`}>
                  {item.rank}
                </div>
                <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2 py-1 rounded-md">{item.tag}</span>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-fill text-accent-500"></i>
                热度 <span className="font-semibold text-foreground-700 ml-1">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          {rankingData.slice(3).map((item) => (
            <div
              key={item.rank}
              className="relative bg-background-50 rounded-xl p-4 border border-background-200/50 hover:border-accent-300 transition-colors group cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="w-7 h-7 rounded-lg bg-background-200 flex items-center justify-center text-xs font-bold text-foreground-600">
                  {item.rank}
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-500 transition-colors">{item.title}</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">{item.desc}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <span className="text-accent-500 font-semibold">{item.hot}</span>
                <span className="text-foreground-400">热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}